var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLathe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_22797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1042 9.1263C16.1042 8.3213 13.0258 7.66797 9.22925 7.66797C5.43272 7.66797 2.35425 8.3213 2.35425 9.1263",
    stroke: "#B7B7B7",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35425 9.12695C2.35425 9.93195 5.43272 10.5853 9.22925 10.5853C13.0258 10.5853 16.1042 9.93195 16.1042 9.12695",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08333 1L2 9.33333L9.08333 17.6667L16.1667 9.33333L9.08333 1Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_22797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLathe);
export default __webpack_public_path__ + "static/media/ic_lathe.1b3e35806b9af83ce6268b2f2f998370.svg";
export { ForwardRef as ReactComponent };